export default function getFullName(user) {
  const firstName = user?.firstName || '';
  const lastName = user?.lastName || '';

  if (firstName && !lastName) return firstName;

  const fullName = `${firstName} ${lastName}`.trim();
  return fullName || 'User';
}
